import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/app/global-error.js");
